import * as React from 'react'

import { ReactNode, useEffect, useState } from 'react'
import { Button } from '@/components/ui/button'
import { Sheet } from '@/components/ui/sheet'
import FabricForm from '../Fabrics/FabricForm'
import { useDrawerDispatch, useDrawerState } from '@/context/DrawerContext'
import ConfirmationDialog from '@/components/ConfirmationDialog'

interface ComponentProps {
  children: ReactNode
}

export default function ContentDrawer() {
  const isOpen = useDrawerState('isOpen')
  const data = useDrawerState('data')
  const Component = useDrawerState('drawerComponent')
  const dispatch = useDrawerDispatch()

  const [isDirty, setIsDirty] = useState(false)
  const [showConfirm, setShowConfirm] = useState(false)

  const closeDrawerWithWarning = () => {
    dispatch({ type: 'CLOSE_DRAWER' })
  }

  const handleSheetClose = () => {
    if (isDirty) {
      setShowConfirm(true)
    } else {
      closeDrawerWithWarning()
    }
  }

  return (
    <>
      <Sheet
        open={isOpen}
        onOpenChange={open => {
          if (!open) {
            handleSheetClose()
          }
        }}
        modal={true}
      >
        {data &&
          Component &&
          React.createElement(Component, {
            data,
            onDirtyChange: (dirty: boolean) => setIsDirty(dirty),
            onRequestClose: handleSheetClose, // Pass handleSheetClose as onRequestClose
          })}
      </Sheet>

      <ConfirmationDialog
        open={showConfirm}
        onCancel={() => setShowConfirm(false)}
        onConfirm={() => {
          setShowConfirm(false)
          closeDrawerWithWarning()
        }}
      />
    </>
  )
}
